export class StudioProjectAttributesV2Variable {
    constructor() {
        this.name = "";
    }
}
export class StudioProjectAttributesV2VariableNode {
    constructor() {
        this.width = 0;
        this.height = 0;
        this.id = "";
        this.type = "";
        this.selected = false;
        this.dragging = false;
        this.position = { x: 0, y: 0 };
        this.positionAbsolute = { x: 0, y: 0 };
    }
}
export class StudioProjectAttributesV2VariableNodeData {
}
